<template>
  <VaccinationPage
    title="Immunocompromised Patients"
    :buttons="buttons"
    baseRoute="/ImmunocompromisedSecondPage"
    :bottomImage="require('@/assets/page10/Asset 72.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/ImmunocompromisedSecondPage"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page10/Asset 59.png"), name: "Influenza" },
  { imgPath: require("@/assets/page10/Asset 60.png"), name: "Pneumococcal" },
  { imgPath: require("@/assets/page10/Asset 61.png"), name: "RSV" },
  { imgPath: require("@/assets/page10/Asset 62.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page10/Asset 63.png"), name: "Zoster" },
  { imgPath: require("@/assets/page10/Asset 64.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page10/Asset 65.png"), name: "MeningococcalMenB" },
  { imgPath: require("@/assets/page10/Asset 66.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page10/Asset 67.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page10/Asset 68.png"), name: "Humanpapilloma" },
  { imgPath: require("@/assets/page10/Asset 69.png"), name: "MMR" , disabled: true },
  { imgPath: require("@/assets/page10/Asset 70.png"), name: "Varicella", disabled: true },
];
</script>
